import { useContext } from 'react';
import { BasketContext } from '../../providers/BasketProvider';

export default function useBasket() {
  return useContext(BasketContext);
}
